import { composePrice } from "../../../core/utils";

class Controller {
  constructor($mdDialog, Loan, Captain, Events, captainId, Lists) {
    "ngInject";

    this.Events = Events;
    this.Captain = Captain;
    this.Loan = Loan;
    this.captainId = captainId;
    this.$mdDialog = $mdDialog;
    this.Lists = Lists.all;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.loansList = this.Lists.captainLoans;
    this.installmentsInterval = 1;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const type = this.loanType;
    const amount = this.amount;
    const description = this.description;
    const captainId = this.captainId;
    const installments = this.installments;
    const installmentsInterval = this.installmentsInterval;
    const items = {
      type,
      description,
      captain: captainId,
      total_amount: composePrice(amount),
      installments_count: installments,
      installments_interval: installmentsInterval,
    };

    this.isDisabled = true;
    this.Loan.post(items).$promise.then(
      () => {
        this.Events.emit(this.showNotificationEvent, {
          message: "Captain loan added successfully.",
        });
        this.$mdDialog.hide();
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/loanDialog/loanDialog.controller.js